export default __webpack_public_path__ + "static/media/tick.2614b579.svg";